import styled from '@emotion/styled';
import { theme } from '../../styles';

export const TopSpacing = styled.div`
  margin-top: 100px;

  @media (min-width: ${theme.breakpoints.md}) {
    margin-top: ${theme.scale('190px')};
  }
`;